module.exports = __webpack_public_path__ + "img/img8.4a87b1a3.png";